/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationRoleKeySchema = z.enum([
  "Owner",
  "Admin",
  "Member",
  "Moderator",
]);
